import { Modal, Button } from "antd";
import React from "react";

export const ImageViewOnly = ({
  imageOpen,
  imageUrl,
  onClose,
  downloadName,
}) => {
  const handleDownload = async () => {
    if (!imageUrl) return;

    const extensionMatch = String(imageUrl).match(/\.([a-zA-Z0-9]+)(?:\?|$)/);
    const extension = extensionMatch ? extensionMatch[1] : "png";
    const safeName = String(downloadName || "photo")
      .trim()
      .replace(/[\\/:*?"<>|]+/g, "")
      .replace(/\s+/g, " ");
    const fileName = `${safeName || "photo"}.${extension}`;

    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = fileName;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.click();
    }
  };

  const footer = [
    downloadName ? (
      <Button key="download" type="primary" onClick={handleDownload}>
        Download Image
      </Button>
    ) : null,
    <Button key="close" onClick={onClose}>
      Close
    </Button>,
  ].filter(Boolean);

  return (
    <Modal
      title="Image Preview"
      open={imageOpen}
      onCancel={onClose}
      centered
      width={800}
      footer={footer}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        <img
          src={imageUrl}
          alt="Full Preview"
          style={{
            maxWidth: "100%",
            maxHeight: "70vh",
            objectFit: "contain",
          }}
        />
      </div>
    </Modal>
  );
};
